<template>
    <div class="page-wrapper container lg:min-w-[360px] lg:w-1/2 xl:max-w-[900px] mx-auto py-8 px-4 grid gap-2">
        <div class="text-center mb-6">
            <h2>Forgot Password?</h2>
            <p>No worries! Enter your email here and we'll send you a reset link.</p>
        </div>

        <form autocomplete="off" @submit.prevent="sendResetLink" method="post">
            <Alert type="success" title="Success!" v-if="hasSuccess">
                <p>Email was successfully sent to <strong>{{email}}</strong></p>
            </Alert>
            <Alert type="danger" title="Error!" v-if="hasError">
                <span v-html="errorText"></span>
            </Alert>

            <div class="flex flex-col">
                <label for="email" class="text-sm">Email Address</label>
                <input type="email" id="email" class="w-full bg-leonard-white placeholder:text-leonard-black-disabled text-leonard-black rounded lg:rounded-md p-4 border border-leonard-grey-disabled focus:outline-none focus:border-leonard-black-hover" :class="{'border-leonard-error': hasError, 'border-leonard-success': hasSuccess}" placeholder="user@example.com" v-model="email" autofocus required>
                <div class="flex items-center justify-between mt-4">
                    <router-link :to="{name: 'login'}" class="underline text-leonard-green hover:text-leonard-green-hover hover:no-underline">Back to Sign In</router-link>
                    <button type="submit" class="font-medium transition-all duration-300 border-2 rounded-md inline-block py-2 px-3 md:px-4 bg-leonard-green border-leonard-green text-leonard-white hover:bg-leonard-green-hover hover:border-transparent focus:ring-leonard-green cursor-pointer disabled:bg-leonard-green-disabled disabled:text-leonard-green disabled:cursor-not-allowed" :disabled="loading || hasSuccess">
                        Send <font-awesome-icon fixed-width icon="spinner" pulse class="ml-2" v-if="loading"></font-awesome-icon>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {library} from "@fortawesome/fontawesome-svg-core";
    import {faSpinner} from "@fortawesome/free-solid-svg-icons";

    import Alert from "../components/app/Alert";
    import User from '../classes/User';

    export default {
        data() {
            return {
                User: new User(),
                email: null,
                hasError: false,
                hasSuccess: false,
                errorText: '',
                loading: false
            }
        },

        components: {
            Alert,
        },

        created() {
            library.add(faSpinner);
        },

        beforeMount() {
            if(this.loggedIn()) this.$router.push({name: 'home'});
        },

        mounted() {
            document.querySelector('header').classList.add('solid');
            window.events.$emit('finishedLoading');
        },

        methods: {
            sendResetLink() {
                const self = this;
                let data = {
                    emailAddress: this.email
                }

                this.loading = true;
                this.hasError = false;

                this.User.sendResetLink(data).then(response => {
                    if(!response.success) {
                        self.hasError = true;
                        if(response.data === 'password.user') {
                            self.errorText = 'Could not find a user with the provided email address';
                        } else {
                            self.errorText = response.message;
                        }
                    } else {
                        self.hasSuccess = true;
                        feedback('Password reset link has been sent to ' + self.email, 'success');
                    }

                    self.loading = false;
                })
            }
        }
    }
</script>
